var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.71,
    height: 36.159,
    viewBox: "0 0 30.71 36.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7911e15e45bc4e814d791f7e7c63bde4",
    "data-name": "7911e15e45bc4e814d791f7e7c63bde4",
    transform: "translate(0.259 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-4495.905-15786.238a1.737,1.737,0,0,1-1.136-.423,37.059,37.059,0,0,1-9.45-8.846,18.365,18.365,0,0,1-2.7-4.974,18.353,18.353,0,0,1-1.063-5.56v-.052a14.252,14.252,0,0,1,4.221-10.118,14.26,14.26,0,0,1,10.129-4.187h.05a14.356,14.356,0,0,1,4.219.646,7.318,7.318,0,0,0-4.266,6.641,7.305,7.305,0,0,0,7.3,7.3,7.289,7.289,0,0,0,3.9-1.126,7.329,7.329,0,0,0,2.644-2.929,14.372,14.372,0,0,1,.516,3.877v.162c-.061,3.155-1.239,8.083-6.5,13.639a37.885,37.885,0,0,1-6.714,5.53A1.748,1.748,0,0,1-4495.905-15786.238Zm6.856-23.911h-.015a.675.675,0,0,1-.481-.2l-2.414-2.413a.683.683,0,0,1,.02-.949.684.684,0,0,1,.48-.2.7.7,0,0,1,.464.178l1.91,1.91,3.168-4.038a.7.7,0,0,1,.3-.188c.295.3.573.615.827.927a.7.7,0,0,1-.135.2l-3.641,4.55A.7.7,0,0,1-4489.049-15810.149Z",
    transform: "translate(4511 15821.137)",
    fill: "none",
    stroke: "rgba(0,0,0,0.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    transform: "translate(10.493 12.721)",
    fill: "none",
    stroke: "rgba(0,0,0,0.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoctionIcon);
export default __webpack_public_path__ + "static/media/loction-icon.2c54034de283eda5efe6465091195d4f.svg";
export { ForwardRef as ReactComponent };